import { useField } from "formik";
import React, { useCallback } from "react";
import { formatPersonName, hasTooManyNameParts } from "utilities";

import { InputField, type InputFieldProps } from "../InputField";

export type NameFieldProps = Omit<InputFieldProps, "onBlur" | "type">;

/**
 * A person's display name. Rewrites what the user typed into the canonical "Firstname M Lastname"
 * form as soon as they leave the field, so the name they see is the name the API will store.
 */
export const NameField = ({ name, ...props }: NameFieldProps) => {
	const [field, , helpers] = useField<string>({ name });
	const { value } = field;
	const { setValue } = helpers;

	const onBlur = useCallback((): void => {
		// Too many parts is a validation error, not something to quietly reformat away.
		if (hasTooManyNameParts(value)) {
			return;
		}

		const formatted = formatPersonName(value);

		if (formatted !== value) {
			setValue(formatted);
		}
	}, [setValue, value]);

	return <InputField name={name} onBlur={onBlur} type="text" {...props} />;
};
